import { sailthruCompletedModal, sailthruReOptIn } from '../utils/sailthruFunctions';

export const trackEvents = (response, email) => {
  console.log('Track Events Response:', response);
  // Facebook Events
  window?.fbevents && window?.fbq?.('track', 'Lead');
  window?.send_client_app_events && window?.sendAppEvent('track', 'Lead');

  // Sailthru
  sailthruCompletedModal(response, 'Campaign Claim');

  if (window?.sailthruReOptIn) {
    const params = { email: email };

    if (window?.current_campaign) {
      params.source = window.current_campaign.name;
    }

    sailthruReOptIn(params, function () { });
  }

  // GTM & Rudderstack
  if (window?.promotion) {
    window?.claimPromotionGtmEvent(window.promotion, response);

    window?.generateLeadRudderstackEvent?.('Claim', response.lead, response.coupon, response.prefix);
  }
};
